import axios from "axios";
import qs from 'qs';
import tokenService from '../services/token';
import { API_URL_v2, API_URL_v3 } from "../env";


export interface ResponseSuccess<T> {
  status?: boolean;
  data: T;
  message?: string;
}

export interface ResponseSuccessSL<T> {
  data: T;
}

export interface ResponseSuccessTotal<T> {
  status: boolean
  data: T
  msg: string
}
export interface ResponseError {
  status?: number,
  title: string,
  errors: {
    [key: string]: string[]
  }
}



const axiosClient = (baseURL: string) => {
  const instance = axios.create({
    baseURL,
    headers: {
      "content-type": "multipart/form-data",
    },
    paramsSerializer: {
      serialize: params => qs.stringify(params, { arrayFormat: "repeat", allowDots: true }),
    },
  });

  instance.interceptors.request.use(async config => {
    // const token = tokenService.getToken();
    const token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6MSwidGltZSI6MTc0NDE4MTQ1NSwiaXAiOiIxNzEuMjUyLjE1NS4yMSJ9.QVj0i4Nn3nbGPQak5AimocJu5sdC5XE7qbD3aNvxchU"
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  instance.interceptors.response.use((response) => {
    if (response && response.data) {
      return response.data;
    }
    return response;
  }, (error) => {
    if (error.code === 'ERR_CONNECTION_TIMED_OUT') {
      // Lỗi do timeout
      return Promise.resolve({
        status: false,
        data: null,
        message: 'Không có phản hồi từ hệ thống',
      } as ResponseSuccess<null>);
    } else
      if (error.response && error.response.data && error.response.data.error &&
        (error.response.data.session === false || error.response.data.session === "false")) {
        // alert("Đã xảy ra sự cố, sẽ tự động đăng xuất.");
        window.location.href = "/";
      } else if (error?.response && error.response?.data && error.response.data.error && error.response.data.error.message) {
        return error?.response?.data
      } else if (error.response && error.response.status === 500) {
        return error?.response?.data;
      } else if (error?.response && error?.response?.status === 401) {
        return Promise.reject(error);
      } else {
        return error?.response?.data;
      }
    Promise.reject(error);
  });

  return instance;
};

export default axiosClient;
